/**
 * ============================================================================
 * MIGRATED FILE — DO NOT EDIT
 * ============================================================================
 *
 * This file has been migrated to academy-content-ui.
 * Canonical source: academy-content-ui/static/js/features/toolRecommendations/components/ShortsRecommendations/ShortContentFullToolRecommendations.tsx
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-content-ui. All changes should be made in
 * academy-content-ui first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 *
 * @migrated-to academy-content-ui
 * ============================================================================
 */
import FormattedMessage from 'I18n/components/FormattedMessage';
import { SprocketIcon } from 'foundations-assets/icons/components/SprocketIcon';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { H2 } from 'foundations-components/transitional/components/H2';
import { ToolRecommendationsForLearningContent } from '../ToolRecommendationsForLearningContent.migrated';
import { useGetToolRecommendations } from '../../hooks/softwareDiscoveryHooks.migrated';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const ShortContentFullToolRecommendations = ({
  contentLanguage,
  contentName,
  useCases,
  toolsToDisplay = 3
}) => {
  const toolRecommendations = useGetToolRecommendations(useCases, contentLanguage);
  const {
    shortTitleKey = '',
    descriptionKey = ''
  } = toolRecommendations || {};
  if (!toolRecommendations) {
    return null;
  }
  return /*#__PURE__*/_jsx(Flex, {
    alignItems: "center",
    backgroundColor: "fill-tertiary-pressed",
    blockSize: "100%",
    flexDirection: "column",
    inlineSize: "100%",
    justifyContent: "center",
    paddingBlock: "700",
    paddingInline: "700",
    children: /*#__PURE__*/_jsx(ToolRecommendationsForLearningContent, {
      cardWidth: 250,
      contentLanguage: contentLanguage,
      contentName: contentName,
      flexGap: "1000",
      renderRecommendations: commonContent => {
        return /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(View, {
            marginBlock: "500",
            children: /*#__PURE__*/_jsxs(Flex, {
              alignItems: "center",
              flexDirection: "column",
              justifyContent: "center",
              children: [/*#__PURE__*/_jsxs(Flex, {
                alignItems: "center",
                inlineSize: "100%",
                justifyContent: "space-between",
                children: [/*#__PURE__*/_jsx(View, {
                  inlineSize: "72px"
                }), /*#__PURE__*/_jsx(H2, {
                  children: /*#__PURE__*/_jsx(FormattedMessage, {
                    message: shortTitleKey
                  })
                }), /*#__PURE__*/_jsx(SprocketIcon, {
                  color: "fill-brand-default",
                  size: "1100"
                })]
              }), /*#__PURE__*/_jsx(Text, {
                color: "text-core-default",
                textAlign: "center",
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: descriptionKey
                })
              })]
            })
          }), /*#__PURE__*/_jsx(View, {
            marginBlock: "500",
            children: commonContent
          })]
        });
      },
      toolsToDisplay: toolsToDisplay,
      useCases: useCases
    })
  });
};

/**
 * @migrated-to academy-content-ui
 * @deprecated
 * This file has been migrated to academy-content-ui.
 * Canonical source: academy-content-ui/static/js/features/toolRecommendations/components/ShortsRecommendations/ShortContentFullToolRecommendations.tsx
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-content-ui. All changes should be made in
 * academy-content-ui first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 */
export default ShortContentFullToolRecommendations;